import { TRegionKey } from '@source/interface';
import { getStaticCDN, getStaticCDNFixedDimension } from '@design-system/utils/utils';
import { MetaDataProps, MetaDataPropsWithLang } from '@source/pages/Home/components/HeadMeta/HeadMetaProps';

const IMAGE_SIZE: { width: string; height: string } = {
  width: '1200',
  height: '630',
};

const MY_META_DATA: MetaDataProps | MetaDataPropsWithLang = {
  index: {
    title: `The Best Place to Buy & Sell Cars | Carro`,
    metaTitle: 'The Best Place to Buy & Sell Cars | Carro',
    description:
      'Buy used car, sell used car online easily in Malaysia at Carro. Beli & Jual kereta terpakai dengan mudah & selamat. Tempat jual kereta di Malaysia terpercaya.',
    image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
    ...IMAGE_SIZE,
  },
  home: {
    en: {
      title: 'Carro Malaysia - Best Place Online to Buy & Sell Used Cars',
      metaTitle: 'Carro Malaysia - Best Place Online to Buy & Sell Used Cars',
      description:
        "Carro is Malaysia's No.1 online platform to buy & sell used cars with transparent pricing, comprehensive inspections, and nationwide services.",
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: ' Carro 马来西亚 —— 最佳线上买卖二手车平台',
      metaTitle: 'Carro Malaysia - 最佳线上买卖二手车平台',
      description: 'Carro 是马来西亚第一线上买卖二手车平台，不仅价格透明化，还提供全方位验车，服务范围覆盖全国各地。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Carro Malaysia - Beli & Jual Kereta Terpakai secara Online',
      metaTitle: 'Carro Malaysia - Beli & Jual Kereta Terpakai secara Online',
      description:
        'Carro ialah platform online No.1 Malaysia untuk beli & jual kereta terpakai dengan harga telus, pemeriksaan ketat, dan perkhidmatan di seluruh negara.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  sell: {
    en: {
      title: 'Sell Your Used Car with Carro Malaysia - Fast & Best Price',
      metaTitle: 'Sell Your Used Car with Carro Malaysia - Fast & Best Price',
      description:
        'Sell your used car with Carro Malaysia. Get a free inspection, our best price and enjoy quick payment. Trusted by satisfied customers.',
      image: getStaticCDNFixedDimension('/assets/my/meta-thumb/Carro_Metatag_1200x628.png', 1200, 628),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Jual Kereta Terpakai dengan Carro - Cepat & Harga Terbaik',
      metaTitle: 'Jual Kereta Terpakai dengan Carro - Cepat & Harga Terbaik',
      description:
        'Jual kereta terpakai anda dengan Carro Malaysia dengan harga terbaik. Tempah pemeriksaan percuma, dapatkan tawaran terbaik kami dan bayaran segera.',
      image: getStaticCDNFixedDimension('/assets/my/meta-thumb/Carro_Metatag_1200x628.png', 1200, 628),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: '在Carro 马来西亚卖您的二手车 —— 快速又高价',
      metaTitle: '在Carro 马来西亚卖您的二手车 —— 快速又高价',
      description: '在Carro 马来西亚卖您的二手车，可获享免费验车、高价回收及快速付款，值得信赖。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  certified: {
    title: 'Carro Certified',
    metaTitle: 'Carro Certified',
    description:
      'Buying with Carro is easy & hassle free. Enjoy doorstep delivery of Carro Certified Cars with 5-Day Money Back Guarantee & 1-Year Extended Warranty',
    image: getStaticCDN('/my/img/Carro-seo-v2.jpg'),
    ...IMAGE_SIZE,
  },
  userProfileIndex: {
    en: {
      title: 'My Profile | Carro',
      metaTitle: 'My Profile | Carro',
      description: 'View personal information, browsing history and more. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Profil Saya | Carro',
      metaTitle: 'Profil Saya | Carro',
      description: 'Lihat maklumat peribadi, sejarah penyemakan imbas dan banyak lagi.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: '我的简介 | Carro',
      metaTitle: '我的简介 | Carro',
      description: '查看个人信息、浏览历史等。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  userProfilePersonalInfo: {
    en: {
      title: 'Edit Personal Info | Carro',
      metaTitle: 'Edit Personal Info | Carro',
      description: 'Update personal information and contact details. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Edit Maklumat Peribadi | Carro',
      metaTitle: 'Edit Maklumat Peribadi | Carro',
      description: 'Kemas kini maklumat peribadi dan butiran hubungan.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: '编辑个人信息 | Carro',
      metaTitle: '编辑个人信息 | Carro',
      description: '更新个人信息和联系方式。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  ccpoIndex: {
    en: {
      title: 'All Carro Certified Cars in Malaysia Come with 5 Guarantees',
      metaTitle: 'All Carro Certified Cars in Malaysia Come with 5 Guarantees',
      description:
        'Carro Certified used cars in Malaysia include a 12-month engine & gearbox warranty, 5-day money back guarantee, no major accidents and more.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Semua Kereta Carro Certified di Malaysia Ada 5 Jaminan',
      metaTitle: 'Semua Kereta Carro Certified di Malaysia Ada 5 Jaminan',
      description:
        'Kereta Carro Certified di Malaysia ada waranti 12 bulan untuk enjin & kotak gear, jaminan pulangan wang dalam 5 hari, & tiada kerosakan serius. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: '所有马来西亚Carro 官方认证汽车均享有五大保障',
      metaTitle: '所有马来西亚Carro 官方认证汽车均享有五大保障',
      description: '马来西亚的 Carro 官方认证二手车享有12个月引擎和变速箱售后保固、5天退款保证、无经历重大事故等。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  locateUsIndex: {
    en: {
      title: 'Find Carro Malaysia Locations',
      metaTitle: 'Find Carro Malaysia Locations',
      description:
        'Find and locate a Carro branch in Malaysia. Drop by for a free inspection, service or test drive a Carro Certified used car that is As Good As New.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Cari Lokasi Carro Malaysia',
      metaTitle: 'Cari Lokasi Carro Malaysia',
      description:
        'Cari dan temui cawangan Carro di Malaysia. Sila datang untuk pemeriksaan percuma, servis atau pandu uji kereta Carro Certified Sebaik Yang Baru.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: '搜索Carro 马来西亚位置',
      metaTitle: '搜索Carro 马来西亚位置',
      description: '搜索 Carro 马来西亚分行位置。欢迎前来免费验车、保养，或试驾完好如新的 Carro 官方认证二手车。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  expiredOTT: {
    en: {
      title: 'Check In Failed',
      description:
        'Oops! Your Check-in Has Failed because your link has expired. Please find a Product Genius near you to check-in again!',
    },
    ms: {
      title: 'Check In Failed',
      description:
        'Oops! Your Check-in Has Failed because your link has expired. Please find a Product Genius near you to check-in again!',
    },
    'zh-MY': {
      title: 'Check In Failed',
      description:
        'Oops! Your Check-in Has Failed because your link has expired. Please find a Product Genius near you to check-in again!',
    },
  },
  viewingHistoryIndex: {
    en: {
      title: 'Viewing History | Carro',
      metaTitle: 'Viewing History | Carro',
      description: 'View personal information, browsing history and more. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Sejarah Pencarian | Carro',
      metaTitle: 'Sejarah Pencarian | Carro',
      description: 'Lihat maklumat peribadi, sejarah penyemakan imbas dan banyak lagi.        ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: '浏览纪录 | Carro',
      metaTitle: '浏览纪录 | Carro',
      description: '查看个人信息、浏览历史等。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  promotionNFCIndex: {
    en: {
      title: "Here's how we make it as good as new | Carro",
      metaTitle: "Here's how we make it as good as new | Carro",
      description: 'From exterior to interior, every Carro Certified car is as good as new ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Cara kami ubah suai agar tampak seperti baru | Carro',
      metaTitle: 'Cara kami ubah suai agar tampak seperti baru | Carro',
      description: 'Dari bahagian luar ke dalam, setiap kereta Carro Certified berfungsi seperti baru',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: 'H以下就是我们确保 as good as new 的应对方案',
      metaTitle: 'H以下就是我们确保 as good as new 的应对方案',
      description: '无论是车子的外观还是内部，每一部Carro认证的车子都是 as good as new',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  error: {
    en: {
      title: 'Error | Carro',
      metaTitle: 'Error | Carro',
    },
    ms: {
      title: 'Ralat | Carro',
      metaTitle: 'Ralat | Carro',
    },
    'zh-MY': {
      title: '错误 | Carro',
      metaTitle: '错误 | Carro',
    },
  },
  workshop: {
    en: {
      title: 'Carro Care - Comprehensive Car Service & Repair in Malaysia',
      metaTitle: 'Carro Care - Comprehensive Car Service & Repair in Malaysia',
      description:
        'Enjoy professional comprehensive maintenance & repair services at Carro Care Malaysia. Reach out to us today and service your car with Carro Care.',
      image: getStaticCDNFixedDimension('assets/my/meta-thumb/workshop_Metatag_1200x628.jpg', 1200, 628),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Carro Care - Servis & Pembaikan Kereta di Seluruh Malaysia',
      metaTitle: 'Carro Care - Servis & Pembaikan Kereta di Seluruh Malaysia',
      description:
        'Nikmati penyelenggaraan & pembaikan kereta profesional di Carro Care Malaysia. Hubungi kami hari ini untuk servis kereta anda dengan Carro Care.',
      image: getStaticCDNFixedDimension('assets/my/meta-thumb/workshop_Metatag_1200x628.jpg', 1200, 628),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: 'Carro Care —— 遍布全马的全方位汽车保养与维修',
      metaTitle: 'Carro Care —— 遍布全马的全方位汽车保养与维修',
      description:
        '在 Carro Care 马来西亚享有专业全面的保养与维修服务。立即联系我们，把您的爱车交给 Carro Care，让我们为您用心呵护。',
      image: getStaticCDNFixedDimension('assets/my/meta-thumb/workshop_Metatag_1200x628.jpg', 1200, 628),
      ...IMAGE_SIZE,
    },
  },
  termsAndConditions: {
    en: {
      title: `Carro Malaysia Terms of Use`,
      metaTitle: 'Carro Malaysia Terms of Use',
      description:
        "Read Carro Malaysia's Terms of Use outlining user agreements, privacy policies, and service conditions for buying and selling vehicles.",
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: `Terma Penggunaan Carro Malaysia`,
      metaTitle: 'Terma Penggunaan Carro Malaysia',
      description:
        'Sila baca Terma Penggunaan Carro Malaysia tentang persetujuan pengguna, polisi privasi, dan syarat perkhidmatan untuk membeli dan menjual kereta.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: `Carro 马来西亚使用条款`,
      metaTitle: 'Carro 马来西亚使用条款',
      description: '买车或卖车时，请详阅Carro 马来西亚的使用条款，包括用户协议、隐私政策和服务条款。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  zeekr: {
    en: {
      title: 'Book a Zeekr with Carro - an authorised Zeekr dealer',
      metaTitle: 'Book a Zeekr with Carro - an authorised Zeekr dealer',
      description:
        'Drive the Zeekr model of your dreams. Book the 009, X, and 7X and enjoy Carro’s introductory price in Malaysia now!',
      image: getStaticCDN('/assets/shared/meta-thumb/Zeekr_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Tempah kereta Zeekr dengan Carro - pengedar sah Zeekr',
      metaTitle: 'Tempah kereta Zeekr dengan Carro - pengedar sah Zeekr',
      description:
        'Miliki model Zeekr idaman anda. Tempah kereta 009, X, dan 7X dan nikmati harga permulaan Carro di Malaysia sekarang!',
      image: getStaticCDN('/assets/shared/meta-thumb/Zeekr_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: '在 Zeekr 授权经销商 —— Carro 预订 Zeekr 车款',
      metaTitle: '在 Zeekr 授权经销商 —— Carro 预订 Zeekr 车款',
      description: '驾驶您梦想中的 Zeekr 车款。预订009、X及7X，尊享 Carro 马来西亚独家受发优惠！',
      image: getStaticCDN('/assets/shared/meta-thumb/Zeekr_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  contact: {
    en: {
      title: 'Get in Touch with Carro Malaysia - Visit or Contact Us Today',
      metaTitle: 'Get in Touch with Carro Malaysia - Visit or Contact Us Today',
      description:
        'Need help? Contact Carro Malaysia for inquiries, support, or feedback. Our team is ready to assist you with all your car buying and selling needs.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Sila Hubungi Carro Malaysia atau Datang ke Lokasi Kami',
      metaTitle: 'Sila Hubungi Carro Malaysia atau Datang ke Lokasi Kami',
      description:
        'Perlukan bantuan? Hubungi Carro Malaysia untuk sebarang pertanyaan atau maklum balas. Kami bersedia untuk membantu anda membeli dan menjual kereta.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-MY': {
      title: '与Carro 马来西亚取得联系 —— 立即到访或联系我们',
      metaTitle: '与Carro 马来西亚取得联系 —— 立即到访或联系我们',
      description:
        '有任何疑问？欢迎联系Carro 马来西亚，无论是咨询、支援或意见反馈，我们的团队随时为您提供买车与卖车方面的全方位协助。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
};

const SG_META_DATA: MetaDataProps | MetaDataPropsWithLang = {
  index: {
    en: {
      title: 'Carro - Best Place Online to Buy & Sell Used Cars',
      metaTitle: 'Carro - Best Place Online to Buy & Sell Used Cars',
      description:
        "Carro is Singapore's No.1 online platform to buy & sell used cars with transparent pricing, thorough inspections, and nationwide services.",
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'ms-SG': {
      title: 'Tempat terbaik untuk membeli dan menjual kereta terpakai di Singapura',
      metaTitle: 'Tempat terbaik untuk membeli dan menjual kereta terpakai di Singapura',
      description:
        'Pasaran kereta terpakai AI terbesar di Singapura yang memberikan anda ketelusan dan jaminan kualiti apabila membeli dan menjual kereta terpakai.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: 'Carro 新加坡——最佳线上买卖二手车平台',
      metaTitle: 'Carro 新加坡——最佳线上买卖二手车平台',
      description: 'Carro 是新加坡第一线上买卖二手车平台，不仅价格透明化，还提供全方位验车，服务范围覆盖新加坡全岛。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Carro Singapore - Beli & Jual Kereta Terpakai secara Online',
      metaTitle: 'Carro Singapore - Beli & Jual Kereta Terpakai secara Online',
      description:
        'Carro ialah platform online No.1 Singapura untuk beli & jual kereta terpakai dengan harga telus, pemeriksaan ketat, & perkhidmatan di seluruh negara.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  home: {
    en: {
      title: 'Carro - Best Place Online to Buy & Sell Used Cars',
      metaTitle: 'Carro - Best Place Online to Buy & Sell Used Cars',
      description:
        "Carro is Singapore's No.1 online platform to buy & sell used cars with transparent pricing, thorough inspections, and nationwide services.",
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'ms-SG': {
      title: 'Tempat terbaik untuk membeli dan menjual kereta terpakai di Singapura',
      metaTitle: 'Tempat terbaik untuk membeli dan menjual kereta terpakai di Singapura',
      description:
        'Pasaran kereta terpakai AI terbesar di Singapura yang memberikan anda ketelusan dan jaminan kualiti apabila membeli dan menjual kereta terpakai.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: 'Carro 新加坡——最佳线上买卖二手车平台',
      metaTitle: 'Carro 新加坡——最佳线上买卖二手车平台',
      description: 'Carro 是新加坡第一线上买卖二手车平台，不仅价格透明化，还提供全方位验车，服务范围覆盖新加坡全岛。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Carro Singapore - Beli & Jual Kereta Terpakai secara Online',
      metaTitle: 'Carro Singapore - Beli & Jual Kereta Terpakai secara Online',
      description:
        'Carro ialah platform online No.1 Singapura untuk beli & jual kereta terpakai dengan harga telus, pemeriksaan ketat, & perkhidmatan di seluruh negara.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  sell: {
    en: {
      title: 'Sell Your Used Car with Carro Singapore - Fast & Best Price',
      metaTitle: 'Sell Your Used Car with Carro Singapore - Fast & Best Price',
      description:
        'Sell your used car with Carro Singapore. Get a free car evaluation, our best offer and enjoy quick payment. Trusted by satisfied customers.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'ms-SG': {
      title: 'Menjual kereta untuk lebih | Carro Car Mart Singapura',
      metaTitle: 'Menjual kereta untuk lebih | Carro Car Mart Singapura',
      description:
        'Jual kereta anda di Singapura dengan harga tertinggi di platform menjual kereta Carro. Penilaian adil & pakar. Tiada tawaran bola rendah. Dapatkan respons dalam masa 15 minit.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: '在Carro 新加坡卖您的二手车 —— 快速又高价',
      metaTitle: '在Carro 新加坡卖您的二手车 —— 快速又高价',
      description: '在Carro新加坡卖您的二手车，可获享免费估价、高价回收及快速付款，值得信赖。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Jual Kereta dengan Carro Singapore - Cepat & Harga Terbaik',
      metaTitle: 'Jual Kereta dengan Carro Singapore - Cepat & Harga Terbaik',
      description:
        'Jual kereta terpakai anda dengan Carro Singapura. Dapatkan penilaian kereta percuma dan tawaran terbaik kami dengan bayaran pantas. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  express: {
    title: 'Sell Car In 1 hour | Carro Used Car Marketplace',
    metaTitle: 'Sell Car For Cash | Carro Car Mart Singapore',
    description:
      'Get a value for your used car within 1 hour and enjoy full paperwork services to for the fastest car selling experience.',
    image: 'https://carro.sg/assets/img/meta_express_new_100619.jpg',
    ...IMAGE_SIZE,
  },
  coe_renewal: {
    title: 'COE Renewal Loan | Approved in 24 hours | Carro Singapore',
    metaTitle: 'Renew COE Car Loan Online | Carro Singapore',
    description:
      'Enjoy a low-interest COE renewal loan for your car when you do it online with Carro! Get your loan approved in just 1 day & we will handle all the paperwork. Learn more now.',
    image: 'https://carro.sg/assets/img/meta_coe_loan_100619.jpg',
    ...IMAGE_SIZE,
  },
  usedCarLoan: {
    title: 'Get a Used Car Loan Online | Approved in 24 hours | Carro Singapore',
    metaTitle: 'Lowest Used Car Loans | Carro Car Mart Singapore',
    description:
      'Finance your used car with Carro’s flexible, low interest car loan options. Get the loan approved for your second-hand car in just 1 day! Find out more now.',
    image: 'https://carro.sg/assets/img/meta_loan_new_100619.jpg',
    ...IMAGE_SIZE,
  },
  about: {
    title: "About Us | SEA's Largest Car Marketplace | Carro Singapore",
    metaTitle: 'About Us - Automotive Marketplace in Singapore | Carro',
    description:
      'As an automotive marketplace in Singapore, Carro makes selling, buying & subscribing to cars online a worry-free & transparent experience for Singaporeans. Learn more about us here.',
    image: 'https://carro.sg/assets/img/meta_about_100619.jpg',
    ...IMAGE_SIZE,
  },
  faq: {
    title: 'Frequently Asked Questions | Carro Singapore',
    metaTitle: 'Most Commonly Asked Questions | Carro Car Mart Singapore',
    description:
      'Check out the frequently asked questions about selling & buying cars on Carro. Get more information about our services now.',
    image: 'https://carro.sg/assets/img/meta_about_100619.jpg',
    ...IMAGE_SIZE,
  },
  team: {
    title: 'Join Us | Career Opportunities at Carro Singapore',
    metaTitle: 'Career Opportunities - Join Us | Carro Singapore',
    description:
      'Want to experience working in a start-up environment? Check out our current job openings here! Cant find what youre looking for? Send us your resume now!',
    image: 'https://carro.sg/assets/img/meta_team_new_100619.jpg',
    ...IMAGE_SIZE,
  },
  termsAndCondition: {
    title: 'Terms & Conditions | Carro Singapore',
    metaTitle: 'Privacy Policy | Carro Car Mart Singapore',
    description:
      'Carro respects your privacy, and is committed to protect it. Check out our terms & conditions and privacy policy here. Learn more now.',
    image: 'https://carro.sg/assets/img/meta_terms_100619.jpg',
    ...IMAGE_SIZE,
  },
  contact: {
    en: {
      title: 'Get in Touch with Carro Singapore - Contact Us Today',
      metaTitle: 'Get in Touch with Carro Singapore - Contact Us Today',
      description:
        'Need help? Contact Carro Singapore for inquiries, support, or feedback. Our team is ready to assist you with all your car buying and selling needs.',
      image: 'https://carro.sg/assets/img/meta_contact_100619.jpg',
      ...IMAGE_SIZE,
    },
    'ms-SG': {
      title: 'Sila Hubungi Carro Singapore Hari Ini',
      metaTitle:
        'Perlukan bantuan? Hubungi Carro Singapore untuk sebarang pertanyaan atau maklum balas. Kami bersedia untuk membantu anda membeli dan menjual kereta.',
      description:
        'Perlukan bantuan? Hubungi Carro Singapore untuk sebarang pertanyaan atau maklum balas. Kami bersedia untuk membantu anda membeli dan menjual kereta.',
      image: 'https://carro.sg/assets/img/meta_contact_100619.jpg',
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Sila Hubungi Carro Singapore Hari Ini',
      metaTitle:
        'Perlukan bantuan? Hubungi Carro Singapore untuk sebarang pertanyaan atau maklum balas. Kami bersedia untuk membantu anda membeli dan menjual kereta.',
      description:
        'Perlukan bantuan? Hubungi Carro Singapore untuk sebarang pertanyaan atau maklum balas. Kami bersedia untuk membantu anda membeli dan menjual kereta.',
      image: 'https://carro.sg/assets/img/meta_contact_100619.jpg',
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: '与Carro 新加坡取得联系 —— 立即到访或联系我们',
      metaTitle: '与Carro 新加坡取得联系 —— 立即到访或联系我们',
      description:
        '有任何疑问？欢迎联系Carro 新加坡，无论是咨询、支援或意见反馈，我们的团队随时为您提供买车与卖车方面的全方位协助。',
      image: 'https://carro.sg/assets/img/meta_contact_100619.jpg',
      ...IMAGE_SIZE,
    },
  },
  workshop: {
    en: {
      title: 'Carro Care - Comprehensive Car Service & Repair in Singapore',
      metaTitle: 'Carro Care - Comprehensive Car Service & Repair in Singapore',
      description:
        'Enjoy professional comprehensive maintenance & repair services at Carro Care Singapore. Reach out to us today and service your car with Carro Care.',
      image: 'https://carro.sg/assets/img/meta_carro_workshop.jpg',
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Carro Care - Servis & Pembaikan Kereta di Singapura',
      metaTitle: 'Carro Care - Servis & Pembaikan Kereta di Singapura',
      description:
        'Nikmati penyelenggaraan & pembaikan kereta profesional di Carro Care Singapura. Hubungi kami hari ini untuk servis kereta anda dengan Carro Care.',
      image: 'https://carro.sg/assets/img/meta_carro_workshop.jpg',
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: 'Carro Care——遍布新加坡全岛的全方位汽车保养与维修',
      metaTitle: 'Carro Care——遍布新加坡全岛的全方位汽车保养与维修',
      description:
        '在Carro Care 新加坡享有专业全面的保养与维修服务。立即联系我们，把您的爱车交给 Carro，让我们为您用心呵护。',
      image: 'https://carro.sg/assets/img/meta_carro_workshop.jpg',
      ...IMAGE_SIZE,
    },
  },
  howItWorks: {
    title: 'How it Works | Car Repair and Maintenance Service | Carro Singapore',
    metaTitle: 'Transparent & Trustworthy Car Repairs and Servicing Workshop | Carro Workshop',
    description:
      'Wondering how does Carro’s car repair workshop works? Click here to learn more on how we provide reliable car mechanic services in Singapore now.',
    image: 'https://carro.sg/assets/img/meta_carro_workshop.jpg',
    ...IMAGE_SIZE,
  },
  getAQuote: {
    title: 'Get a Quote at the Best Car Workshop in Singapore | Carro Singapore',
    metaTitle: 'Transparent & Trustworthy Car Repairs and Servicing Workshop | Carro Workshop',
    description:
      'Wondering how does Carro’s car repair workshop works? Click here to learn more on how we provide reliable car mechanic services in Singapore now.',
    image: 'https://carro.sg/assets/img/meta_carro_workshop.jpg',
    ...IMAGE_SIZE,
  },
  newCar: {
    title: 'New Cars At Best Prices | Carro New Car Marketplace',
    metaTitle: 'Buy New Car At Best Prices | Carro New Car Marketplace',
    description: 'Get your next new car for the best prices in the market, exclusively at Carro.',
    image: 'https://carro.sg/assets/img/meta_newcar_home_100619.jpg',
    ...IMAGE_SIZE,
  },
  leasing: {
    title: 'Monthly Car Rental & Leasing Subscription Services | Carro',
    metaTitle: 'Carro.sg: Affordable Car Rental, Car Leasing and Car Subscription services',
    description:
      'Looking for a short-term car rental or car leasing company in Singapore? Subscribe to our monthly car rental service now & lease a car for a month, or for as long as you want!',
    image: 'https://carro.sg/assets/img/meta_leasing_100619.jpg',
    ...IMAGE_SIZE,
  },
  leap: {
    title: 'Rent Car Singapore | Lease Car Singapore | Leap by Carro',
    metaTitle:
      'Carro offers short-term car rental service in Singapore for new & pre-owned cars on a monthly basis. Rent a car by subscribing to our flexible car lease plans!',
    description:
      'Carro offers short-term car rental service in Singapore for new & pre-owned cars on a monthly basis. Rent a car by subscribing to our flexible car lease plans!',
    image: 'https://carro.sg/assets/img/meta_leasing_100619.jpg',
    ...IMAGE_SIZE,
  },
  anywhere: {
    title: "Singapore's 1st 24/7 Car Showroom I Carro Anywhere",
    metaTitle: 'Buy, Sell and Lease New and Used cars, Entirely Online | Carro Singapore',
    description:
      "View and inspect cars with greater convenience and hygiene in Singapore's first 24/7 contactless car showroom - Carro Anywhere. Experience the future of car buying today!",
    image: 'https://carro.sg/assets/img/meta_home_100619.jpg',
    ...IMAGE_SIZE,
  },
  certified: {
    title: 'Carro Certified',
    metaTitle: 'Carro Certified',
    description:
      "Certified pre-owned cars for sale at Carro's contactless second-hand car purchase service in Singapore. Buy a car with a 30-day guarantee & 3-day return policy.",
    image: 'https://carro.sg/assets/img/meta_home_100619.jpg',
    ...IMAGE_SIZE,
  },
  userProfileIndex: {
    en: {
      title: 'My Profile | Carro Singapore',
      metaTitle: 'My Profile | Carro Singapore',
      description: 'View personal information, browsing history and more. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: '我的简介 | Carro 新加坡',
      metaTitle: '我的简介 | Carro 新加坡',
      description: '查看个人信息、浏览历史等。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'ms-SG': {
      title: 'Profil saya | Carro Singapura',
      metaTitle: 'Profil saya | Carro Singapura',
      description: 'Lihat maklumat peribadi, sejarah penyemakan imbas dan banyak lagi.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  userProfilePersonalInfo: {
    en: {
      title: 'Edit Personal Info | Carro Singapore',
      metaTitle: 'Edit Personal Info | Carro Singapore',
      description: 'Update personal information and contact details. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: '编辑个人信息 | Carro 新加坡',
      metaTitle: '编辑个人信息 | Carro 新加坡',
      description: '更新个人信息和联系方式。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'ms-SG': {
      title: 'Edit Maklumat Peribadi | Carro Singapura',
      metaTitle: 'Edit Maklumat Peribadi | Carro Singapura',
      description: 'Kemas kini maklumat peribadi dan butiran hubungan.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  ccpoIndex: {
    en: {
      title: 'All Carro Certified Cars in Singapore Come with 5 Guarantees',
      metaTitle: 'All Carro Certified Cars in Singapore Come with 5 Guarantees',
      description:
        'Carro Certified used cars in Singapore include a 12-month engine & gearbox warranty, 5-day money back guarantee, no major accidents and more.',
      image: 'https://carro.sg/assets/img/meta_home_100619.jpg',
      ...IMAGE_SIZE,
    },
    // Todo_CCPO: waiting translation
    'zh-SG': {
      title: '所有新加坡Carro 官方认证汽车均享有五大保障',
      metaTitle: '所有新加坡Carro 官方认证汽车均享有五大保障',
      description: '新加坡的 Carro 官方认证二手车享有12个月引擎和变速箱售后保固、5天退款保证、无经历重大事故等。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'ms-SG': {
      title: 'Carro Disahkan',
      metaTitle: 'Carro Disahkan',
      description:
        'Kereta pra-milik yang disahkan untuk dijual di perkhidmatan pembelian kereta terpakai Carro di Singapura. Beli kereta dengan dasar pulangan jaminan 30 hari & 3 hari.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Semua Kereta Carro Certified di Singapura Ada 5 Jaminan',
      metaTitle: 'Semua Kereta Carro Certified di Singapura Ada 5 Jaminan',
      description:
        'Kereta Carro Certified di Singapura ada waranti 12 bulan untuk enjin & kotak gear, jaminan pulangan wang dalam 5 hari & tiada kerosakan serius. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  locateUsIndex: {
    en: {
      title: 'Find Carro Singapore Locations',
      metaTitle: 'Find Carro Singapore Locations',
      description:
        'Find and locate a Carro branch in Singapore. Drop by for a free inspection, service or test drive a Carro Certified used car that is As Good As New.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: '搜索Carro新加坡位置',
      metaTitle: '搜索Carro新加坡位置',
      description: '搜索Carro 新加坡分行位置。欢迎前来免费验车、保养，或试驾完好如新的 Carro 官方认证二手车。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'ms-SG': {
      title: 'Cari Lokasi Carro Singapore',
      metaTitle: 'Cari Lokasi Carro Singapore',
      description:
        'Cari dan temui cawangan Carro di Singapura. Sila datang untuk pemeriksaan percuma, servis atau pandu uji kereta Carro Certified Sebaik Yang Baru.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Cari Lokasi Carro Singapore',
      metaTitle: 'Cari Lokasi Carro Singapore',
      description:
        'Cari dan temui cawangan Carro di Singapura. Sila datang untuk pemeriksaan percuma, servis atau pandu uji kereta Carro Certified Sebaik Yang Baru.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  expiredOTT: {
    en: {
      title: 'Check In Failed',
      description:
        'Oops! Your Check-in Has Failed because your link has expired. Please find a Product Genius near you to check-in again!',
    },
    'zh-SG': {
      title: 'Check In Failed',
      description:
        'Oops! Your Check-in Has Failed because your link has expired. Please find a Product Genius near you to check-in again!',
    },
  },
  viewingHistoryIndex: {
    en: {
      title: 'Viewing History | Carro Singapore',
      metaTitle: 'Viewing History | Carro Singapore',
      description: 'View personal information, browsing history and more.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: '浏览纪录 | Carro 新加坡',
      metaTitle: '浏览纪录 | Carro 新加坡',
      description: '查看个人信息、浏览历史等。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'ms-SG': {
      title: 'Melihat Sejarah | Carro Singapura',
      metaTitle: 'Melihat Sejarah | Carro Singapura',
      description: 'Lihat maklumat peribadi, menyemak imbas sejarah dan banyak lagi.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  error: {
    en: {
      title: 'Error | Carro Singapore',
      metaTitle: 'Error | Carro Singapore',
    },
    'zh-SG': {
      title: '错误 | Carro 新加坡',
      metaTitle: '错误 | Carro 新加坡',
    },
    'ms-SG': {
      title: 'Ralat | Carro Singapura',
      metaTitle: 'Ralat | Carro Singapura',
    },
  },
  buyNew: {
    en: {
      title: 'Buy Brand New Cars Online with Carro Singapore',
      metaTitle: 'Buy Brand New Cars Online with Carro Singapore',
      description:
        'Buy your new car online with Carro Singapore. 1-Bid COE Guarantee, 10-Year Warranty for Engine & Gearbox, Zero Downpayment. Book your new car today!',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: '在Carro新加坡线上购买新车',
      metaTitle: '在Carro新加坡线上购买新车',
      description:
        '在Carro 新加坡线上购买新车，可享有1次竞标COE保障、10年引擎和变速箱售后保固，以及$0首付。立即向我们预订您的新车！',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Beli Kereta Baru secara Online dengan Carro Singapore',
      metaTitle: 'Beli Kereta Baru secara Online dengan Carro Singapore',
      description:
        'Beli kereta baru dengan Carro Singapore. Jaminan COE dalam 1 bidaan, waranti 10 tahun untuk enjin & kotak gear, tanpa pendahuluan. Tempah sekarang!',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  termsAndConditions: {
    en: {
      title: 'Carro Singapore Terms of Use',
      metaTitle: 'Carro Singapore Terms of Use',
      description:
        "Read Carro Singapore's Terms of Use outlining user agreements, privacy policies, and service conditions for buying and selling vehicles.",
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ms: {
      title: 'Terma Penggunaan Carro Singapore',
      metaTitle: 'Terma Penggunaan Carro Singapore',
      description:
        'Sila baca Terma Penggunaan Carro Singapore tentang persetujuan pengguna, polisi privasi, dan syarat perkhidmatan untuk membeli dan menjual kereta.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-SG': {
      title: 'Carro 新加坡使用条款',
      metaTitle: 'Carro 新加坡使用条款',
      description: '买车或卖车时，请详阅 Carro新加坡的使用条款，包括用户协议、隐私政策和服务条款。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
};

const TH_META_DATA: MetaDataProps | MetaDataPropsWithLang = {
  index: {
    title: `คิดจะขายรถ คิดถึงเรา | Carro`,
    metaTitle: 'คิดจะขายรถ คิดถึงเรา | Carro',
    description:
      'คิดจะขายรถ คิดถึง Carro | Carro ย่อมาจาก Car Hero เปรียบเสมือนฮีโร่ในทุกๆด้านของรถของทุกคน โดยเพียงส่งข้อมูลรถทีต้องการจะขาย Car Hero จะทำการค้นหาราคาที่ดีสุดผ่านระบบเฉพาะของ Carro และส่งราคาที่เหมาะสมที่สุดสำหรับรถคันนั้นๆ โดยสามารถปรึกษาเรื่องการขายรถกับพวกเราได้ตลอดเวลา',
    image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
    ...IMAGE_SIZE,
  },
  home: {
    title: 'Carro เว็บซื้อ-ขายรถมือสอง สะดวก ปลอดภัย เชื่อถือได้ บริการฟรี!',
    metaTitle: 'Carro เว็บซื้อ-ขายรถมือสอง สะดวก ปลอดภัย เชื่อถือได้ บริการฟรี!',
    description:
      'ต้องการซื้อ-ขายรถยนต์ นึกถึงคาร์โร จะซื้อ-ขายรถบ้านบนเว็บก็ง่าย หรือจะซื้อ-ขายรถจำนวนมากก็ทำได้ผ่านแอปฯ Carro Wholesale สะดวก ปลอดภัย ถูกใจทั้งผู้ซื้อและผู้ขาย',
    image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
    ...IMAGE_SIZE,
  },
  sell: {
    title: 'บริการขายรถจบด่วน ภายใน 24ชม. ขายฟรี ได้เงินชัวร์ | Carro Express',
    metaTitle: 'บริการขายรถจบด่วน ภายใน 24ชม. ขายฟรี ได้เงินชัวร์ | Carro Express',
    description:
      'ร้อนเงิน ร้อนใจ ไม่รู้จะขายรถที่ไหน? มาที่ Carro สิ พร้อมรับซื้อรถของคุณในราคาที่คุณพอใจ ขายรถได้เร็ว บริการฟรี ไม่มีค่าธรรมเนียม รับเงินสดทันที',
    image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
    ...IMAGE_SIZE,
  },
  certified: {
    title: 'รับประกันคุณภาพโดย Carro',
    metaTitle: 'รับประกันคุณภาพโดย Carro',
    description:
      'Carro Certified ให้คุณมั่นใจในคุณภาพตามมาตรฐานการตรวจสอบจากผู้เชี่ยวชาญ ทั้งภายนอกและภายในมากถึง 160 จุด รับประกันเครื่องยนต์และเกียร์ ไม่กรอไมล์ ไม่ประสบอุบัติเหตุหนัก ไฟไหม้ หรือน้ำท่วม',
    image: getStaticCDN('/static/img/logo-orange.jpg'),
    ...IMAGE_SIZE,
  },
  userProfileIndex: {
    en: {
      title: 'My Profile | Carro Thailand',
      metaTitle: 'My Profile | Carro Thailand',
      description: 'View personal information, browsing history and more. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    th: {
      title: 'โปรไฟล์ของฉัน | Carro Thailand',
      metaTitle: 'โปรไฟล์ของฉัน | Carro Thailand',
      description: 'ดูข้อมูลส่วนบุคคล ประวัติการเข้าชม และอื่นๆ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  userProfilePersonalInfo: {
    en: {
      title: 'Edit Personal Info | Carro Thailand',
      metaTitle: 'Edit Personal Info | Carro Thailand',
      description: 'Update personal information and contact details. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    th: {
      title: 'แก้ไขข้อมูลส่วนบุคคล | Carro Thailand',
      metaTitle: 'แก้ไขข้อมูลส่วนบุคคล | Carro Thailand',
      description: 'อัปเดตข้อมูลส่วนบุคคลและรายละเอียดการติดต่อ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  ccpoIndex: {
    en: {
      title: 'Carro Certified',
      metaTitle: 'Carro Certified',
      description:
        'Carro Certified cars go through a rigorous 160-point inspection checklist. Enjoy 12-month warranty for engine and gearbox. No mileage tampering, no major accidents, fire or flood damage.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    th: {
      title: 'รับประกันคุณภาพโดย Carro',
      metaTitle: 'รับประกันคุณภาพโดย Carro',
      description:
        'Carro Certified ให้คุณมั่นใจในคุณภาพตามมาตรฐานการตรวจสอบจากผู้เชี่ยวชาญ ทั้งภายนอกและภายในมากถึง 160 จุด รับประกันเครื่องยนต์และเกียร์ ไม่กรอไมล์ ไม่ประสบอุบัติเหตุหนัก ไฟไหม้ หรือน้ำท่วม',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  locateUsIndex: {
    en: {
      title: 'The Best Place to Buy & Sell Cars | Carro',
      metaTitle: 'The Best Place to Buy & Sell Cars | Carro',
      description:
        'Buy used cars, sell used cars online easily in Thailand at Carro. Buy & sell used cars easily & safely.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    th: {
      title: 'The Best Place to Buy & Sell Cars | Carro',
      metaTitle: 'The Best Place to Buy & Sell Cars | Carro',
      description:
        'Buy used cars, sell used cars online easily in Thailand at Carro. Buy & sell used cars easily & safely.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  viewingHistoryIndex: {
    en: {
      title: 'Viewing History | Carro Thailand',
      metaTitle: 'Viewing History | Carro Thailand',
      description: 'View personal information, browsing history and more.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    th: {
      title: 'ประวัติการเข้าชม | Carro Thailand',
      metaTitle: 'ประวัติการเข้าชม | Carro Thailand',
      description: 'ดูข้อมูลส่วนบุคคล ประวัติการเข้าชม และอื่นๆ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  error: {
    en: {
      title: 'Error | Carro Thailand',
      metaTitle: 'Error | Carro Thailand',
    },
    th: {
      title: 'ความผิดพลาด | Carro Thailand',
      metaTitle: 'ความผิดพลาด | Carro Thailand',
    },
  },
};

const ID_META_DATA: MetaDataProps | MetaDataPropsWithLang = {
  index: {
    title: `Platform mobil Bekas Terbesar Di Indonesia | Carro Indonesia`,
    metaTitle: 'Platform Mobil Bekas Terbesar di Indonesia',
    description:
      'Pilih mobil bekas dari berbagai pilihan ✓ Mobil bekas berkualitas, telah diinspeksi dan bergaransi ✓ Pelayanan dan harga terbaik ✓ Baca review dan harga mobil terbaru 2023 ✓',
    image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
    ...IMAGE_SIZE,
  },
  home: {
    title: `Platform mobil Bekas Terbesar Di Indonesia | Carro Indonesia`,
    metaTitle: 'Platform Mobil Bekas Terbesar di Indonesia',
    description:
      'Pilih mobil bekas dari berbagai pilihan ✓ Mobil bekas berkualitas, telah diinspeksi dan bergaransi ✓ Pelayanan dan harga terbaik ✓ Baca review dan harga mobil terbaru 2023 ✓',
    image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
    ...IMAGE_SIZE,
  },
  sell: {
    title: 'Jual Mobil Cepat & Mudah | Carro Indonesia',
    metaTitle: 'Jual Mobil Bekas di Indonesia Cepat & Mudah Gratis',
    description:
      'Jual mobil bekas cepat dan mudah ✓ Pelayanan jual dan inspeksi mobil seken gratis dan terpercaya ✓ Dapatkan harga mobil bekas tertinggi ✓',
    image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
    ...IMAGE_SIZE,
  },
  automall: {
    title: 'Showroom Mobil Bekas Bersertifikasi Terbesar | Carro Automall',
    metaTitle: 'Showroom Mobil Bekas Bersertifikasi Terbesar | Carro Automall',
    description:
      'Carro Automall menyediakan ratusan stok mobil bekas bersertifikasi dengan keuntungan 90 hari garansi transmisi mesin, bebas banjir tabrak dan bukan mobil curian, serta Beli sekarang!',
    image: getStaticCDN('/static/img/meta_sell_100619.jpg'),
    ...IMAGE_SIZE,
  },
  contact: {
    title: 'Hubungi Kami | Carro Indonesia',
    metaTitle: 'Hubungi Kami | Carro Indonesia',
    description:
      '[Carro.id](http://carro.id/) adalah platform transaksi mobil bekas bersertifikasi di Indonesia. [Carro.id](http://carro.id/) inspeksi real-time, garansi mobil, dan 50 opsi pembiayaan cash & kredit.',
    image: getStaticCDN('/static/img/meta_sell_100619.jpg'),
    ...IMAGE_SIZE,
  },
  certified: {
    title: 'Carro Certified',
    metaTitle: 'Carro Certified',
    description: 'Carro Certified',
    image: getStaticCDN('/static/img/meta_sell_100619.jpg'),
    ...IMAGE_SIZE,
  },
  certifiedInspectionPoints: {
    title: 'Carro Certified',
    metaTitle: 'Carro Certified',
    description: 'Carro Certified',
    image: getStaticCDN('/static/img/meta_sell_100619.jpg'),
    ...IMAGE_SIZE,
  },
  userProfileIndex: {
    en: {
      title: 'My Profile | Carro Indonesia',
      metaTitle: 'My Profile | Carro Indonesia',
      description: 'View personal information, browsing history and more. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    id: {
      title: 'Profil Saya | Carro Indonesia',
      metaTitle: 'Profil Saya | Carro Indonesia',
      description: 'Lihat informasi pribadi, riwayat penelusuran, dan lainnya.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  userProfilePersonalInfo: {
    en: {
      title: 'Edit Personal Info | Carro Indonesia',
      metaTitle: 'Edit Personal Info | Carro Indonesia',
      description: 'Update personal information and contact details. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    id: {
      title: 'Sunting Info Pribadi | Carro Indonesia',
      metaTitle: 'Sunting Info Pribadi | Carro Indonesia',
      description: 'Perbarui informasi pribadi dan detail kontak.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  ccpoIndex: {
    en: {
      title: 'Carro Certified',
      metaTitle: 'Carro Certified',
      description:
        'Carro Certified cars go through a rigorous 160-point inspection checklist. Enjoy 12-month warranty for engine and gearbox. No mileage tampering, no major accidents, fire or flood damage.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    id: {
      title: 'Carro Certified',
      metaTitle: 'Carro Certified',
      description:
        'Carro Certified cars go through a rigorous 160-point inspection checklist. Enjoy 12-month warranty for engine and gearbox. No mileage tampering, no major accidents, fire or flood damage.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  locateUsIndex: {
    en: {
      title: 'The Best Place to Buy & Sell Cars | Carro',
      metaTitle: 'The Best Place to Buy & Sell Cars | Carro',
      description:
        'Buy used cars, sell used cars online easily in Indonesia at Carro. Buy & sell used cars easily & safely.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    id: {
      title: 'The Best Place to Buy & Sell Cars | Carro',
      metaTitle: 'The Best Place to Buy & Sell Cars | Carro',
      description:
        'Buy used cars, sell used cars online easily in Indonesia at Carro. Buy & sell used cars easily & safely.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  viewingHistoryIndex: {
    en: {
      title: 'Viewing History | Carro Indonesia',
      metaTitle: 'Viewing History | Carro Indonesia',
      description: 'View personal information, browsing history and more. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    id: {
      title: 'Riwayat Penelusuran | Carro Indonesia',
      metaTitle: 'Riwayat Penelusuran | Carro Indonesia',
      description: 'Lihat informasi pribadi, riwayat penelusuran, dan lainnya.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  error: {
    en: {
      title: 'Error | Carro Indonesia',
      metaTitle: 'Error | Carro Indonesia',
    },
    id: {
      title: 'Salah | Carro Indonesia',
      metaTitle: 'Salah | Carro Indonesia',
    },
  },
};

const JP_META_DATA: MetaDataProps | MetaDataPropsWithLang = {
  home: {
    en: {
      title: 'Carro Japan - A Trusted Place to Buy & Sell Used Cars Online',
      metaTitle: 'Carro Japan - A Trusted Place to Buy & Sell Used Cars Online',
      description:
        'Carro is a trusted, reliable platform to buy & sell used cars and EVs in Japan. Enjoy great deals, financing options and quality used cars.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ja: {
      title: '中古車販売・買取は安心のCarro',
      metaTitle: '中古車販売・買取は安心のCarro',
      description: '多彩な品揃えと充実保証の認定中古車制度。中古EVの品揃えは国内最大級。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  sell: {
    en: {
      title: 'Sell Your Used Car with Carro Japan - Fast & Best Price',
      metaTitle: 'Sell Your Used Car with Carro Japan - Fast & Best Price',
      description: `Sell your used car with Carro Japan. Get a free car evalutation, our best offer and enjoy quick payment. Trusted by satisfied customers.`,
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ja: {
      title: '愛車を高価買取、スピード払い',
      metaTitle: '愛車を高価買取、スピード払い',
      description: `無料買取査定からスピード支払い。不当な減額、しつこい営業一切なし。多くの高評価レビューが満足の証です。`,
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  userProfileIndex: {
    en: {
      title: 'My Profile | Carro Japan',
      metaTitle: 'My Profile | Carro Japan',
      description: 'View personal information, browsing history and more. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ja: {
      title: 'マイプロフィール | Carro 日本',
      metaTitle: 'マイプロフィール | Carro 日本',
      description: '登録情報、閲覧履歴などを表示。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  userProfilePersonalInfo: {
    en: {
      title: 'Edit Personal Info | Carro Japan',
      metaTitle: 'Edit Personal Info | Carro Japan',
      description: 'Update personal information and contact details. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ja: {
      title: '登録情報の編集 | Carro 日本',
      metaTitle: '登録情報の編集 | Carro 日本',
      description: '登録情報、連絡先の詳細を更新。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  ccpoIndex: {
    en: {
      title: 'All Carro Certified Cars in Japan Come with 5 Guarantees',
      metaTitle: 'All Carro Certified Cars in Japan Come with 5 Guarantees',
      description:
        'Carro Certified used cars in Japan include a 12-month engine & gearbox warranty, 15-day money back guarantee, 30-day comprehensive warranty and more.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ja: {
      title: '充実保証、あんしんのCarro認定中古車',
      metaTitle: '充実保証、あんしんのCarro認定中古車',
      description: 'エンジン・ギアボックス12ヶ月保証、30日間あんしん保証つきのCarro認定中古車。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  locateUsIndex: {
    en: {
      title: 'Find Carro Japan Locations',
      metaTitle: 'Find Carro Japan Locations',
      description:
        'Find and locate a Carro branch in Japan. Drop by for a free inspection, service or test drive a Carro Certified used car that is As Good As New.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ja: {
      title: '店舗紹介 Carroの中古車販売・買取',
      metaTitle: '店舗紹介 Carroの中古車販売・買取',
      description:
        'Carro認定中古車の販売、無料買取はもちろん、Carroはお客さまのカーライフを全力サポート。お気軽にご来店ください。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  contact: {
    en: {
      title: 'Get in Touch with Carro Japan - Contact Us Today',
      metaTitle: 'Get in Touch with Carro Japan - Contact Us Today',
      description:
        'Need help? Contact Carro Japan for inquiries, support, or feedback. Our team is ready to assist you with all your car buying and selling needs.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ja: {
      title: 'Carroへのご連絡はこちら',
      metaTitle: 'Carroへのご連絡はこちら',
      description: '中古車に関するご質問、お悩みのご相談はぜひCarroに。誠心誠意お答えします。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  viewingHistoryIndex: {
    en: {
      title: 'Viewing History | Carro Japan',
      metaTitle: 'Viewing History | Carro Japan',
      description: 'View personal information, browsing history and more. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    ja: {
      title: '閲覧履歴 | Carro 日本',
      metaTitle: '閲覧履歴 | Carro 日本',
      description: '登録情報、閲覧履歴などを表示。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  error: {
    en: {
      title: 'Error | Carro Japan',
      metaTitle: 'Error | Carro Japan',
    },
    ja: {
      title: 'エラー | Carro 日本',
      metaTitle: 'エラー | Carro 日本',
    },
  },
  about: {
    en: {
      title: 'About Carro Japan - Your Trusted Used Car Platform',
      metaTitle: 'About Carro Japan - Your Trusted Used Car Platform',
      description:
        'Learn about Carro Japan. Our mission, technology and values. We make buying and selling used cars easy, safe, and fully transparent.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
    },
    ja: {
      title: 'Carroグループ・会社概要',
      metaTitle: 'Carroグループ・会社概要',
      description: '透明性の高い中古車売買とお客さまへの安心の提供をCarroはお約束します。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
    },
  },
};

const HK_META_DATA: MetaDataProps | MetaDataPropsWithLang = {
  index: {
    en: {
      title: 'Carro Hong Kong - Best Place Online to Buy & Sell Used Cars ',
      metaTitle: 'Carro Hong Kong - Best Place Online to Buy & Sell Used Cars ',
      description: `Carro is Hong Kong's No.1 online platform to buy & sell used cars with transparent pricing, thorough inspections, and nationwide services.`,
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: 'Carro 香港——最佳網上二手車買賣平台',
      metaTitle: 'Carro 香港——最佳網上二手車買賣平台',
      description: 'Carro 是香港 No.1 網上二手車買賣平台，價格透明合理，並提供徹底檢查服務，服務範圍遍佈全港。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: 'Carro 香港——线上二手车交易首选平台',
      metaTitle: 'Carro 香港——线上二手车交易首选平台',
      description: '定价透明、检测全面、服务全国——Carro凭借卓越服务成为香港首屈一指的二手车在线交易平台。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  home: {
    en: {
      title: 'Carro Hong Kong - Best Place Online to Buy & Sell Used Cars ',
      metaTitle: 'Carro Hong Kong - Best Place Online to Buy & Sell Used Cars ',
      description: `Carro is Hong Kong's No.1 online platform to buy & sell used cars with transparent pricing, thorough inspections, and nationwide services.`,
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: 'Carro 香港——最佳網上二手車買賣平台',
      metaTitle: 'Carro 香港——最佳網上二手車買賣平台',
      description: 'Carro 是香港 No.1 網上二手車買賣平台，價格透明合理，並提供徹底檢查服務，服務範圍遍佈全港。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: 'Carro 香港——线上二手车交易首选平台',
      metaTitle: 'Carro 香港——线上二手车交易首选平台',
      description: '定价透明、检测全面、服务全国——Carro凭借卓越服务成为香港首屈一指的二手车在线交易平台。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  sell: {
    en: {
      title: 'Sell Your Used Car with Carro Hong Kong - Fast & Best Price',
      metaTitle: 'Sell Your Used Car with Carro Hong Kong - Fast & Best Price',
      description: `Sell your used car with Carro Hong Kong. Get a free inspection, our best price and enjoy quick payment. Trusted by satisfied customers.`,
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: '賣二手車，搵 Carro 香港 - 價錢極佳、報價合理',
      metaTitle: '賣二手車，搵 Carro 香港 - 價錢極佳、報價合理',
      description: `搵 Carro 香港賣二手車，即可享有免費驗車服務，獲得最佳價格並迅速攞錢。服務深受客戶信賴。`,
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: 'Carro 香港卖车平台——快速成交、优价保障',
      metaTitle: 'Carro 香港卖车平台——快速成交、优价保障',
      description: `卖车首选 Carro 香港，尊享免费检测、高价保障和快速收款等一系列深受客户信赖的服务。`,
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  userProfileIndex: {
    en: {
      title: 'My Profile | Carro Hong Kong',
      metaTitle: 'My Profile | Carro Hong Kong',
      description: 'View personal information, browsing history and more. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: '我的簡介 | Carro 香港',
      metaTitle: '我的簡介 | Carro 香港',
      description: '查看個人資料、瀏覽紀錄等。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: '我的简介 | Carro 香港',
      metaTitle: '我的简介 | Carro 香港',
      description: '查看个人信息、浏览历史等。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  userProfilePersonalInfo: {
    en: {
      title: 'Edit Personal Info | Carro Hong Kong',
      metaTitle: 'Edit Personal Info | Carro Hong Kong',
      description: 'Update personal information and contact details. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: '編輯個人資料 | Carro 香港',
      metaTitle: '編輯個人資料 | Carro 香港',
      description: '更新個人資訊和聯絡方式。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: '编辑个人信息 |  Carro 香港',
      metaTitle: '编辑个人信息 |  Carro 香港',
      description: '更新个人信息和联系方式。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  ccpoIndex: {
    en: {
      title: 'All Carro Certified Cars in Hong Kong Come with 5 Guarantees',
      metaTitle: 'All Carro Certified Cars in Hong Kong Come with 5 Guarantees',
      description:
        'Carro Certified used cars in Hong Kong include a 12-month engine & gearbox warranty, 5-day return policy, no major accidents and more. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: 'Carro 官方认证二手车在香港提供五大保障承诺',
      metaTitle: 'Carro 官方认证二手车在香港提供五大保障承诺',
      description: '香港 Carro 官方认证的二手车，享一年引擎&变速箱保修、五天退车保障、无经历重大事故记录等多项保障',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: '所有香港 Carro 官方認證汽車都提供 5 大保證',
      metaTitle: '所有香港 Carro 官方認證汽車都提供 5 大保證',
      description: '香港 Carro 官方認證二手車包含 12 個月引擎及波箱保養期、5 日換車保證、絕無重大事故記錄等保證。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  locateUsIndex: {
    en: {
      title: 'Find Carro Hong Kong Locations',
      metaTitle: 'Find Carro Hong Kong Locations',
      description:
        'Find and locate a Carro branch in Hong Kong. Drop by for a free inspection, service or test drive a Carro Certified used car that is As Good As New. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: '尋找Carro香港位置',
      metaTitle: '尋找Carro香港位置',
      description:
        '搜尋各間 Carro香港分店。造訪我們的分店以獲得免費驗車、汽車維護服務，或試揸完好如新的 Carro 官方認證二手車。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: '寻找Carro香港门店位置',
      metaTitle: '寻找Carro香港门店位置',
      description: 'Carro 香港门店导航：亲临体验免费检测服务，试驾完好如新的Carro官方认证二手车',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  contact: {
    en: {
      title: 'Get in Touch with Carro Hong Kong - Contact Us Today',
      metaTitle: 'Get in Touch with Carro Hong Kong - Contact Us Today',
      description:
        'Need help? Contact Carro Hong Kong for inquiries, support, or feedback. Our team is ready to assist you with all your car buying and selling needs. ',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: '與 Carro 香港聯繫 - 立即聯絡我們',
      metaTitle: '與 Carro 香港聯繫 - 立即聯絡我們',
      description:
        '需要幫助？立即聯絡 Carro 香港查詢、獲取支援或意見。我們的團隊會隨時協助你，解決你的所有汽車買賣疑難。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: '即刻联系Carro香港，获享专属服务',
      metaTitle: '即刻联系Carro香港，获享专属服务',
      description: '需要帮助？敬请咨询 Carro 香港获取帮助或提供宝贵建议。购车售车全流程支持，专业团队随时待命。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  about: {
    en: {
      title: 'About Carro Hong Kong - Your Trusted Used Car Platform',
      metaTitle: 'About Carro Hong Kong - Your Trusted Used Car Platform',
      description:
        'Learn about Carro Hong Kong. Our mission, technology and values. We make buying and selling used cars easy, safe, and fully transparent.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
    },
    'zh-Hant-HK': {
      title: '關於 Carro 香港 - 你值得信賴的二手車平台',
      metaTitle: '關於 Carro 香港 - 你值得信賴的二手車平台',
      description: '了解 Carro 香港的使命、技術和價值觀。我們令二手車買賣輕鬆、安全、完全透明。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: '关于Carro香港——您值得信赖的二手车交易平台',
      metaTitle: '关于Carro香港——您值得信赖的二手车交易平台',
      description: '了解 Carro 香港的使命、技术与价值观。打造简单、安全、透明的二手车交易平台。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  viewingHistoryIndex: {
    en: {
      title: 'Viewing History | Carro Hong Kong',
      metaTitle: 'Viewing History | Carro Hong Kong',
      description: 'View personal information, browsing history and more.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: '瀏覽歷史 | Carro 香港',
      metaTitle: '瀏覽歷史 | Carro 香港',
      description: '查看個人資料、瀏覽歷史等。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: '浏览历史 | Carro 香港',
      metaTitle: '浏览历史 | Carro 香港',
      description: '查看个人信息、浏览历史等。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  finance: {
    en: {
      title: 'Carro Hong Kong Car Loan & Financing – Fast & Easy Approval',
      metaTitle: 'Carro Hong Kong Car Loan & Financing – Fast & Easy Approval',
      description:
        'Get fast car loan approvals with Carro Hong Kong. Apply online for used car financing with low interest rates and flexible repayment options.',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: 'Carro 香港汽車貨款及融資 - 審核快速簡單',
      metaTitle: 'Carro 香港汽車貨款及融資 - 審核快速簡單',
      description: '透過 Carro 香港快速獲批汽車貸款。網上申請二手車貨款，利息低，更提供靈活的還款方式。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: 'Carro香港车贷服务——快审快批',
      metaTitle: 'Carro香港车贷服务——快审快批',
      description: '选择 Carro 香港，快速获取贷款。在线申请二手车贷款，尊享低利率和灵活还款方案。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
  error: {
    en: {
      title: 'Error | Carro Hong Kong',
      metaTitle: 'Error | Carro Hong Kong',
    },
    'zh-Hant-HK': {
      title: '錯誤 | Carro 香港',
      metaTitle: '錯誤 | Carro 香港',
    },
    'zh-Hans-HK': {
      title: '错误 | Carro 香港',
      metaTitle: '错误 | Carro 香港',
    },
  },
  termsAndConditions: {
    en: {
      title: 'Carro Hong Kong Terms of Use',
      metaTitle: 'Carro Hong Kong Terms of Use',
      description: `Read Carro Hong Kong's Terms of Use outlining user agreements, privacy policies, and service conditions for buying and selling vehicles.`,
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hant-HK': {
      title: 'Carro 香港使用條款',
      metaTitle: 'Carro 香港使用條款',
      description: '閱讀 Carro 香港的使用條款，包括買賣汽車的用戶協議、私隱政策及服務細則。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
    'zh-Hans-HK': {
      title: 'Carro 香港使用条款',
      metaTitle: 'Carro 香港使用条款',
      description: 'Carro 香港使用条款，了解用户协议、隐私政策及车辆买卖服务条件。',
      image: getStaticCDN('/assets/shared/meta-thumb/Carro_Metatag_1200x628.png'),
      ...IMAGE_SIZE,
    },
  },
};

const META_DATA: Record<TRegionKey, MetaDataProps> = {
  my: MY_META_DATA,
  sg: SG_META_DATA,
  th: TH_META_DATA,
  id: ID_META_DATA,
  jp: JP_META_DATA,
  hk: HK_META_DATA,
};

export default META_DATA;
